module.exports = __webpack_public_path__ + "static/media/12.10de5b8e.mp3";